import styled from 'styled-components'

import { Color } from 'root-constants'
import { TValueOf } from 'root-types'

export const SEPARATOR_VARIANT = {
  RATING: 'RATING',
  DEFAULT: 'DEFAULT',
} as const

export type TSeparatorVariant = TValueOf<typeof SEPARATOR_VARIANT>

export const StyledSelectGenderV2 = {
  Container: styled.div`
    max-width: 375px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 16px 24px 0;
    margin: 0 auto;
  `,
  Title: styled.h1<{ $isLarge: boolean }>`
    font-size: ${({ $isLarge }) => ($isLarge ? '32px' : '24px')};
    line-height: ${({ $isLarge }) => ($isLarge ? '36px' : '32px')};
    font-weight: 700;
    text-align: center;
    color: ${Color.INK_DARKEST};
  `,
  Subtitle: styled.p`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: ${Color.INK_DARKEST};

    margin-top: 16px;
  `,
  Topic: styled.h2`
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    color: ${Color.INK_DARKEST};

    margin-top: 16px;
  `,
  CardsContainer: styled.div`
    width: 100%;
    height: 295px;
    display: flex;
    flex-direction: row;
    gap: 12px;

    margin: 24px 0 36px;
  `,
  RatingContainer: styled.div`
    display: flex;
    align-items: center;
    background-color: ${Color.WHITE};
    padding: 8px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    border: 1px solid #979ca0;
    margin-bottom: 32px;

    & > svg {
      margin-right: 4px;
    }
  `,
  RatingText: styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 24px 0;
  `,
  Separator: styled.span<{ variant?: TSeparatorVariant }>`
    display: inline-flex;
    height: 16px;
    width: 1px;
    background-color: ${({ variant }) =>
      variant === SEPARATOR_VARIANT.RATING ? 'rgba(0, 0, 0, 0.20)' : '#979CA0'};
    margin: 0 8px;
    vertical-align: middle;
  `,
}

export const StyledRatingSvg = styled.img`
  display: block;
  min-width: 14px;
  min-height: 14px;
  margin-right: 4px;
`
